import React, { useState, useEffect } from "react";

import { withRouter, BrowserRouter, Route } from "react-router-dom";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";

import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import { Container } from "@material-ui/core";
import CssBaseline from "@material-ui/core/CssBaseline";
import { Mixpanel } from "./mixpanel";
import { isMobile } from 'react-device-detect';
import { useRecoilState } from 'recoil'
import { advisorAtom, userAtom} from './atom.js'

const UntiedAppBar = (props) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [user, setUser] = useRecoilState(userAtom)
  const [, setAdvisor] = useRecoilState(advisorAtom)
  //const [, setLoggedInAs] = useState(localStorage.getItem("logged_in_as"))
  const open_width = isMobile ? 240 : 245
  const close_width = isMobile ? 62 : 60

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuLogout = () => {
    setUser({
      agent: "",
      logged_in: false,
      username: "",
      users: []
    })
    setAdvisor({})
    localStorage.clear()
    props.history.push("/login")
  };

  useEffect(()=> {
    // 
    // checks to see if local log in has occurred
    if (!localStorage.getItem("logged_in")){
      localStorage.clear()
 
      localStorage.setItem("logged_in_as", "");
      props.history.push("/login")
    }
  }
  , [user, props])

  const plan = localStorage.has_sub
  const isMenuOpen = Boolean(anchorEl);
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {/* <MenuItem onClick={handleMenuProfile}>Account settings</MenuItem> */}
      <MenuItem onClick={handleMenuLogout}>Logout</MenuItem>
    </Menu>
  );
  const proDivStyle = { marginTop: 10, cursor: 'pointer', width: 150, marginLeft: 'auto', marginRight: 'auto', textAlign: "center" }
  const proStyle = { marginTop: 0, marginBottom: 0, backgroundColor: '#C7FF00', borderRadius: 5, color: '#0C90B2' }

  return (

    < React.Fragment >
      <CssBaseline />
      <Container style={{ maxWidth: "100%" }}>
        <AppBar title="untied web" style={{ backgroundColor: "#0c90b2" }}>
          <Toolbar style={{ height: 80 }}>
            <div style={{ transform: `translateX(${props.open ? open_width : close_width}px)`, transition: "all .4s cubic-bezier(0.42, 0, 0.58, 1.0)" }}>
              {/* <h6 style={{ paddingLeft: 0, margin: 0, textAlign: "left" }}>
                untied V1.6
                </h6> */}
              <Typography variant="h6">
                <BrowserRouter>
                  <Route
                    path="/clients"
                    render={() => <div>Client management 
                    {/* - Personal adviser code: {advisor.agent_code} */}
                    </div>}
                  />
                </BrowserRouter>
              </Typography>
            </div>
            <div style={{ flexGrow: 1 }} />

            <div>
              <div style={{ display: 'flex', flexDirection: 'row', marginLeft: 'auto', marginRight: isMobile ? 10 : 'auto', /* backgroundColor: '#0078c8', padding: 6, borderRadius: 4, cursor: 'pointer'*/ }} /*onClick={handleProfileMenuOpen} */ >
                {/* {!isMobile && (
                  <h4 style={{ paddingTop: 0, paddingBottom: 0, marginTop: 0, marginBottom: 0, lineHeight: "24px", display: 'inline', marginRight: 10 }}>{advisor.username}</h4>
                )} */}
                {/* <IconButton
                  aria-owns={isMenuOpen ? "material-appbar" : undefined}
                  aria-haspopup="true"
                  onClick={handleProfileMenuOpen}
                  color="inherit"
                  style={{ height: '24px', width: '48px', paddingTop: isSafari ? 0 : 10 }}
                >
                  <AccountCircle /><ArrowDropDownIcon />
                </IconButton> */}


              </div>

              {/* {plan === 'N' && (
                <div style={proDivStyle} onClick={() => {
                  Mixpanel.track("clicked_upgrade_button");
                  props.history.push("/profile")
                }}>
                  <h4 style={proStyle}>
                    Upgrade to pro
                  </h4>
                </div>
              )} */}
            </div>
          </Toolbar>
          {renderMenu}
        </AppBar>
      </Container>
    </React.Fragment >
  );
};

export default withRouter(UntiedAppBar)
